import React from 'react';
import { Button, Tooltip, Tag, Table } from 'antd';


const PENDIENTE = 1;
const CANCELADO = 2;
const ANULADO = 3;

export default function ResultListResumen(props) {
    return (
        <Table
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
            dataSource={props.pagination}
            rowKey={record => record.id}
            title={() => (
                <div style={{ width: '100%', textAlign: "right" }}>
                    <div className="custom-options">
                        {
                            props.onExportExcel === undefined ? null :
                                <Button ghost
                                    type="success"
                                    icon="file-excel"
                                    onClick={props.onExportExcel}
                                    style={{ color: '#3fb703' }}
                                    loading={props.loadingExcel}
                                >
                                    Excel
                                </Button>
                        }
                        {
                            props.onExportPdf === undefined ? null :
                                <Button ghost
                                    type="danger"
                                    icon="file-pdf"
                                    onClick={props.onExportPdf}
                                    style={{ color: '#ff4d4f' }}
                                    loading={props.loadingPdf}
                                >
                                    Pdf
                                </Button>
                        }

                    </div>
                </div>
            )}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row, index) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Agregar Comentario">
                                <Button
                                    type="primary"
                                    icon="message"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onComentario(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Generar Comprobante">
                                <Button
                                    type="primary"
                                    icon="container"
                                    size={"small"}
                                    disabled={row.idCreditoEstado === PENDIENTE ? false : true}
                                    loading={props.loadingVer}
                                    onClick={() => props.onInvoice(row, index)}
                                />
                            </Tooltip>
                        </div>
                    )
                },

                {
                    title: 'Nro Cuota',
                    dataIndex: 'correlativo',
                    key: 'correlativo',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Dias Vencidos',
                    dataIndex: 'diasVencidos',
                    key: 'diasVencidos',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                if (value < 0) {
                                    return <Tag color={"red"}>{Math.abs(value)}</Tag>;

                                } else {
                                    if (value == 0) {
                                        return <Tag color={'brown'}>{value > 0 ? 0 : value}</Tag>;
                                    } else {
                                        return <Tag color={'green'}>{CANCELADO == row.idCreditoEstado ? 0 : value}</Tag>;
                                    }
                                }
                            })()}
                        </div>)
                    }
                },

                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                       {
                    title: 'Monto Capital',
                    dataIndex: 'montoCuota',
                    key: 'montoCuota',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Interés',
                    dataIndex: 'interes',
                    key: 'interes',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Monto Cuota',
                    dataIndex: 'totalInteres',
                    key: 'totalInteres',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Documento',
                    dataIndex: 'tipoComprobante',
                    key: 'tipoComprobante',
                    sorter: true
                },
                {
                    title: 'Documento Referencia',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Estado Pago',
                    dataIndex: 'flagPago',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {
                                value ? <Tag color={"green"}>{row.estadoPago}</Tag> :
                                    <Tag color={"red"}>{row.estadoPago}</Tag>
                            }
                        </div>)
                    }
                },

                {
                    title: 'Estado',
                    dataIndex: 'idCreditoEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //pendiente
                                        return <Tag color={"blue"}>{row.estado}</Tag>;
                                    case 2://cancelado
                                        return <Tag color={"orange"}>{row.estado}</Tag>;
                                    case 3://anulado
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    default:
                                        return <Tag color={"purple"}>{row.estado}</Tag>;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}